<template>
<div class="chapter">
<div class="inner_page">
<p class="ded1"><i>Gambling is a biological necessity.…It will be legalized.</i></p>
<p class="ded"><i>—James J. Carroll, in testimony before the Kefauver U.S. Senate hearings, 1951</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Epigraph.vue?09075ff2